import type { ReactNode } from 'react';

/**
 * Нижняя панель действия `.abar` (кит v2.0, v2.11): на телефоне сюда
 * уходит главная кнопка раздела — в шапке раздела `.segbar` кит её
 * прячет. На десктопе панель скрыта. Экрану с ней нужен `.main.has-abar`,
 * чтобы содержимое не уходило под панель.
 */
export function ActionBar({ children }: { children: ReactNode }) {
  return <div className="abar">{children}</div>;
}
